import React from 'react';
import { useTranslation } from 'react-i18next';

// ─── Status badge config ──────────────────────────────────
export const STATUS_STYLE = {
  pending: { bg: '#eff6ff', border: '#bfdbfe', color: '#1d4ed8', label: 'Pending', tKey: 'screens.esign.statusPending' },
  partially_signed: { bg: '#fffbeb', border: '#fde68a', color: '#92400e', label: 'Partially Signed', tKey: 'screens.esign.statusPartial' },
  completed: { bg: '#f0fdf4', border: '#86efac', color: '#15803d', label: 'Completed', tKey: 'screens.esign.statusCompleted' },
  cancelled: { bg: '#f8fafc', border: '#e2e8f0', color: '#64748b', label: 'Cancelled', tKey: 'screens.esign.statusCancelled' },
  expired: { bg: '#fef2f2', border: '#fecaca', color: '#991b1b', label: 'Expired', tKey: 'screens.esign.statusExpired' },
  declined: { bg: '#fef2f2', border: '#fecaca', color: '#991b1b', label: 'Declined', tKey: 'screens.esign.statusDeclined' },
  draft: { bg: '#f8fafc', border: '#e2e8f0', color: '#64748b', label: 'Draft', tKey: 'screens.esign.statusDraft' },
};

const StatusBadge = ({ status }) => {
  const { t } = useTranslation();
  const cfg = STATUS_STYLE[status] || STATUS_STYLE.draft;
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        padding: '3px 10px',
        borderRadius: 20,
        background: cfg.bg,
        border: `1px solid ${cfg.border}`,
        fontSize: 11,
        fontWeight: 700,
        color: cfg.color,
        textTransform: 'uppercase',
        letterSpacing: 0.5,
      }}
    >
      {t(cfg.tKey)}
    </span>
  );
};

export default StatusBadge;
